import React from "react";

type TagProps = {
  children: React.ReactNode;
  type: "sponsored" | "private";
};

const Tag: React.FC<TagProps> = ({ children, type }) => (
  <div className={`${type}-wrapper tag-wrapper`}>
    {children}
  </div>
);

export default Tag;
